<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">忘记密码</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div v-if="!isPasswordSet">
                <div class="phone">
                    <span>手机号</span>
                    <input type="tel" placeholder="请输入绑定手机号" maxlength="11" v-model="phon">
                </div>
                <div class="verify">
                    <span>验证码</span>
                    <input type="tel" maxlength="6" placeholder="请输入验证码" v-model="vcode">
                    <div class="send" v-show="!active" @click="sendOne()">发送</div>
                    <div class="news" v-show="active">
                        <span class="agineOne">重发 {{countOne}}s</span>
                        <!-- <span class="thity">5</span><span v-show="secndes">s</span> -->
                    </div>
                </div>
                <span class="statement">如需帮助，请拨打客服热线：021-80158000</span>
                <button class="next" @click="next">下一步</button>
            </div>
            <div v-else>
                <div class="password">
                    <span>新密码</span>
                    <input :type="typeMode" placeholder="请输入密码" maxlength="12" minlength="6" v-model="pass">
                    <img v-if="!isSee" src="../../assets/images/show.png" @click="changeSeePic">
                    <img v-if="isSee" src="../../assets/images/hide.png" @click="changeSeePic">
                </div>
                <div class="repassword">
                    <span>确认密码</span>
                    <input :type="typeMode" maxlength="12" minlength="6" placeholder="请再次输入密码" v-model="repass">
                    <img v-if="!isSee" src="../../assets/images/show.png" @click="changeSeePic">
                    <img v-if="isSee" src="../../assets/images/hide.png" @click="changeSeePic">
                </div>
                <span class="statement">如需帮助，请拨打客服热线：021-80158000</span>
                <button class="next" @click="finish">完成</button>
            </div>
        </div>
    </div>
</template>
<script>
import validation from "../../assets/js/validation"
import { Toast, Indicator } from "mint-ui"
import { getUserForgetPasswdAction, updateUserPasswdByVcodeAction } from '../../assets/js/api'
export default {
  data() {
    return {
      active: false,
      phon: "",
      vcode: "",   
      countOne: 60,
      downTime:"",
      isPasswordSet: false,
      isSee:false, 
      typeMode: 'tel',
      pass:'',    //新密码
      repass:'',  //确认密码
    };
  },
  computed: {},
  components: {},
  methods: {
    changeSeePic () {
        this.isSee = !this.isSee
        this.typeMode = (this.isSee) ? 'password' : 'tel'
    },
    timer(){
        setInterval(() => {
            const one = this.downTime;
            if (this.countOne > 1 && this.countOne <= one) {
                this.countOne--;
            } else {
                this.active = false;
                clearInterval(this.timer);
                this.timer = null;
            }
        }, 1000)
    },
    // 发送验证码
    newSend(){          
        var regu1 = /^1\d{10}$/;
        if (regu1.test(this.phon)) {
          this.verify = false;
            // 获取验证码 
            getUserForgetPasswdAction(this.phon).then(res => {
                Indicator.close()
              if(res.s==0)
              {
                this.active = true;
                this.downTime=res.nextTime;
                this.timer()

                Toast({
                    message: '发送成功',
                    position: 'middle',
                    duration: 2500
                })
              }
              else
              {
                  this.active=false
              }
            })
            .catch(err=>{
               Indicator.close()
                Toast({
                    message: '网络不给力',
                    position: 'middle',
                    duration: 2500
                   }) 
                });
          } 
      },
    //发送验证码按钮
    sendOne() {
       if(!(/^1[3,4,5,7,8]\d{9}$/.test(this.phon))){
            Toast({
                message: '请输入正确的手机号',
                position: 'middle',
                duration: 2500
            })
        }else{
                  Indicator.open({
                      text: '发送中...',
                      spinnerType: 'fading-circle'
                });

        }
       setTimeout(this.newSend,1000)
    },
    next () {
        let msg = ''
        if ((!this.phon) || (!(/^1[3,4,5,7,8]\d{9}$/.test(this.phon)))) {
            Toast({
                message: '请输入正确的手机号',
                position: 'middle',
                duration: 2500
            })
      } else if (this.vcode==""){
            Toast({
                message: '请输入正确验证码',
                position: 'middle',
                duration: 2500
            })
      } else {
          this.isPasswordSet = true
      }
    },
    finish () {
          //密码长度应为6到12个字符
          var regul = /^[a-zA-Z0-9]\w{5,11}$/;
          if(regul.test(this.pass)){
              //判断两次输入密码是否相同
              if(this.pass == this.repass){
                updateUserPasswdByVcodeAction(this.phon, this.vcode, this.pass)
                .then(res => {
                    console.log("提交修改",res);
                    if (res.s == 0) {
                        Toast:Toast({
                            message:"修改成功",
                            position:"middle",
                            duration: 2500,
                        })
                        this.$router.back()
                    }
                })
                .catch(err => {
                    Toast:Toast({
                        message:"网络不给力，请稍后重试",
                        position:"middle",
                        duration: 2500,
                    })
                })
              }else{
                  Toast:Toast({
                        message:"两次输入密码不一样",
                        position:"middle",
                        duration: 2500,
                    })
              }
          }else{
              Toast:Toast({
                message:"密码长度应为6到12个字符",
                position:"middle",
                duration: 2500,
            })
          }
    },
  }           
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 40%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  font-size: 0.42rem;
  /* background-color: rgba(0, 0, 0, 0.1); */
  height: 100%;
  width: 100%;
}
.phone{
    width: 96%;
    height: 1.47rem;
    line-height: 1.47rem;
    margin-left: 0.2rem;
    border-bottom: 0.03rem solid rgba(0, 0, 0, 0.05);
}
.verify{
    width: 96%;
    height: 1.47rem;
    line-height: 1.47rem;
    margin-left: 0.2rem;
    position: relative;
}
input{
    width: 4rem;
    font-size: 0.42rem;
    border: none;
    margin-left: 1.55rem;
}
.phone span,
.verify span{
    margin-left: 0.26rem;
}
.send{
    width: 2.37rem;
    height: 0.7rem;
    line-height: 0.7rem;
    border-radius: 0.11rem;
    text-align: center;
    font-size: 0.37rem;
    border: 0.03rem solid rgba(0, 0, 0, 1);
    background-color: #fff;
    position: absolute;
    top: 0.45rem;
    right: 0.55rem;
}
.statement{
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.5);
    margin-left: 0.53rem;
}
.next{
    width: 6.71rem;
    height: 1.05rem;
    line-height: 0.61rem;
    border: none;
    border-radius: 0.16rem;
    background-color: rgba(41, 158, 173, 1);
    color: rgba(255, 255, 255, 1);
    letter-spacing: 0.2rem;
    font-size: 0.47rem;
    text-align: center;
    position: relative;
    top: 0.84rem;
    left: 1.58rem;
}
.password{
    width: 96%;
    height: 1.47rem;
    line-height: 1.47rem;
    margin-left: 0.2rem;
    border-bottom: 0.03rem solid rgba(0, 0, 0, 0.05);
    position: relative;
}
.repassword{
    width: 96%;
    height: 1.47rem;
    line-height: 1.47rem;
    margin-left: 0.2rem;
    position: relative;
}
.password input{
    width: 4rem;
    font-size: 0.42rem;
    border: none;
    margin-left: 1.55rem;
}
.repassword input{
    width: 4rem;
    font-size: 0.42rem;
    border: none;
    margin-left: 1.1rem;
}
.password span,
.repassword span{
    margin-left: 0.26rem;
}
img{
    width: 0.53rem;
    height: 0.53rem;
    position: absolute;
    top: 0.45rem;
    right: 0.47rem;
}
</style>



// WEBPACK FOOTER //
// src/components/login/forget.vue